import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  // Scroll reveal effect
  useEffect(() => {
    const revealElements = document.querySelectorAll(".scroll-reveal");
    const handleScroll = () => {
      revealElements.forEach((el) => {
        const top = el.getBoundingClientRect().top;
        if (top < window.innerHeight - 50) {
          el.classList.add("revealed");
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="min-h-screen py-16 px-4 md:px-20"
      style={{ backgroundColor: "var(--bg-1)", color: "var(--brand-dark)" }}
    >
      <div className="container-custom">
 <h1
  className="text-4xl md:text-5xl font-bold mb-12 scroll-reveal text-center"
  style={{ transitionDelay: "0.2s" }}
>
  Privacy Policy
</h1>


        {/* Introduction */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Introduction
          </h2>
          <p className="text-lg leading-relaxed">
            DVV Projects is committed to protecting your privacy and ensuring
            transparency about the information we collect when you use our
            real estate website. This Privacy Policy explains our practices in
            accordance with applicable laws.
          </p>
        </section>

        {/* Information Collection */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Information We Collect
          </h2>
          <p className="text-lg leading-relaxed mb-2">
            We collect information that you voluntarily provide when you:
          </p>
          <ul className="list-disc sm:ml-4 ml-6 text-lg leading-relaxed">
            <li>Fill out inquiry forms for properties or projects</li>
            <li>Subscribe to newsletters or promotional emails</li>
            <li>Contact us via email, phone, or chat support</li>
            <li>Participate in surveys or feedback forms</li>
          </ul>
        </section>

        {/* Use of Information */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            How We Use Your Information
          </h2>
          <p className="text-lg leading-relaxed">
            We use the collected information to:
          </p>
          <ul className="list-disc sm:ml-4 ml-6 text-lg leading-relaxed">
            <li>Provide accurate property information and project updates</li>
            <li>Respond to your inquiries and requests promptly</li>
            <li>Send newsletters, promotional offers, and updates</li>
            <li>Improve our website, services, and user experience</li>
            <li>Comply with legal and regulatory requirements</li>
          </ul>
        </section>

        {/* Data Protection */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Data Security
          </h2>
          <p className="text-lg leading-relaxed">
            We implement industry-standard security measures to protect your
            personal information. Access to your data is restricted to
            authorized personnel only.
          </p>
        </section>

        {/* Cookies */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Cookies & Tracking
          </h2>
          <p className="text-lg leading-relaxed">
            Our website may use cookies and similar tracking technologies to
            enhance your browsing experience and collect analytical data about
            website usage. You can manage cookies in your browser settings.
          </p>
        </section>

        {/* Third-party Sharing */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Third-party Services
          </h2>
          <p className="text-lg leading-relaxed">
            We do not sell your personal information. We may share information
            with trusted partners and service providers solely for business
            purposes, such as sending newsletters or managing property inquiries.
          </p>
        </section>

        {/* Contact Us */}
        <section className="mb-8 md:mb-12 scroll-reveal">

          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Contact Us
          </h2>
          <p className="text-lg leading-relaxed">
            If you have questions about this Privacy Policy, please contact us at:
          </p>
          <ul className="mt-2 text-lg">
            <li>
              <strong>Phone:</strong> <span className="text-brand-gold">+91 7288080999</span>
            </li>
            <li>
              <strong>Email:</strong> <span className="text-brand-gold font-semibold">info@dvvprojects.com</span>
            </li>
            <li>
  <strong>Address:</strong>
 <div className="text-brand-gold mt-1 break-words">
  <strong>Head Office:</strong><br />
  2nd Floor, 28-18-9, Timpany School Road,<br />
  Opposite Indian Overseas Bank, Vuda Colony,<br />
  Gonthinavanipalem, Gajuwaka,<br />
  Visakhapatnam, Andhra Pradesh 530026
  <br /><br />

  <strong>Branch Office:</strong><br />
  D.No 49-49-6, First Floor,<br />
  Beside Arka Hospital, Santhipuram,<br />
  Akkayyapalem,<br />
  Visakhapatnam, Andhra Pradesh 530016
</div>

</li>


          </ul>
        </section>

        {/* Last Updated */}
        <section className="mb-12 scroll-reveal">
          <p className="text-lg text-gray-600 italic">
            Last updated: 22 December 2025
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
